export default __webpack_public_path__ + "static/media/LilNounsReadingLostNouns.f6b368af.png";